import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import PageTitle from '../../../components/PageTitle/PageTitle';
import CardGrid from '../../../components/Layout2/CardGrid/CardGrid';
import { ASSETS_BASE_URL, DEFAULT_LAYOUT } from '../../../config';
import { useTranslation } from 'react-i18next';


const Parts = () => {
    const { t } = useTranslation();
    const isLayout2 = String(DEFAULT_LAYOUT || "").toLowerCase() === "layout2";
    const rsplLabel = isLayout2
        ? t('LABELS.MY_RSPL', { defaultValue: 'My RSPL' })
        : t('LABELS.RSPL');

    const partsData = useMemo(() => ([
        { title: t('LABELS.SEARCH_PARTS'), img: `${ASSETS_BASE_URL}/ImageBoxes/search_parts.jpg`, href: '/search-results?partsonly=true' },
        { title: t('LABELS.MACHINESS'), img: `${ASSETS_BASE_URL}/ImageBoxes/mymachines.jpg`, href: '/machines' },
        { title: rsplLabel, img: `${ASSETS_BASE_URL}/ImageBoxes/myrspl.jpg`, href: '/rspl' },
        { title: t('BUTTON.BUY_AGAIN'), img: `${ASSETS_BASE_URL}/ImageBoxes/buy_again.jpg`, href: '/order-history' },
        { title: t('LABELS.MY_LISTS'), img: `${ASSETS_BASE_URL}/ImageBoxes/my_lists.jpg`, href: '/recommendations' },
        { title: t('LABELS.CUSTOMER_CARE_REQUESTS'), img: `${ASSETS_BASE_URL}/ImageBoxes/customer_care.jpg`, href: '/requests' },
        { title: t('LABELS.SAVED_FOR_LATERS'), img: `${ASSETS_BASE_URL}/ImageBoxes/saved_for_later.jpg`, href: '/saved_for_later' },
        { title: t('LABELS.TRACK_MY_ORDER'), img: `${ASSETS_BASE_URL}/ImageBoxes/track_order.jpg`, href: '/track-quote' },
    ]), [rsplLabel, t]);

    return (
        <Box sx={{ p: 2, pt: 0, pb: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <PageTitle title={t('UI_TEXT.PARTS')} />
            <CardGrid data={partsData} />
        </Box>
    );
};

export default Parts;
